import {useRouter} from 'next/router';
import {useCallback, useContext, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {RESPONSE_STATUSES} from '@/src/app/constants/api';
import {
  selectCountriesDictionarySlice,
  setCountriesDictionary,
  setCountriesDictionaryFetchingStatus,
} from '@/src/app/store/signUp/countriesDictionarySlice';
import useUserActions from '@/src/app/store/user/useUserActions';
import useLoading from '@/src/hooks/useLoading';
import useRoutePaths from '@/src/hooks/useRoutePaths';
import PopupContext from '@/src/popup/utils/PopupContext';
import ChangeAddressPopupLayout from '@/src/profile/accountSettings/components/ChangeAddressPopupLayout';
import updateAddress from '@/src/profile/accountSettings/utils/updateAddress';
import fetchCountriesDictionary from '@/src/signUp/emailStep/utils/fetchCountriesDictionary';
import fetchUserAction from '@/src/signUp/paymentDetails/utils/fetchUserAction';

const ChangeAddressPopup = () => {
  const {isLoading, setLoading} = useLoading();
  const {user, setUserData} = useUserActions();
  const countriesData = useSelector(selectCountriesDictionarySlice);
  const {closePopup} = useContext(PopupContext);
  const {push} = useRouter();
  const dispatch = useDispatch();
  // @ts-ignore
  const {SIGN_IN_ROUTE} = useRoutePaths();

  const fetchUser = useCallback(async () => {
    const {status, responseBody} = await fetchUserAction();

    if (status === RESPONSE_STATUSES.SUCCESS) {
      setUserData(responseBody);
    } else {
      push(SIGN_IN_ROUTE.getLink());
    }
  }, []);

  const handleCancelClick = useCallback(() => {
    closePopup();
  }, []);

  const handleSubmitClick = useCallback(async ({city_id}) => {
    setLoading(true);

    const {status} = await updateAddress(city_id);

    setLoading(false);

    if (status === RESPONSE_STATUSES.SUCCESS) {
      await fetchUser();
      closePopup();
    }
  }, []);

  useEffect(() => {
    const fetchCountriesData = async () => {
      const {responseBody, status} = await fetchCountriesDictionary();

      if (status === RESPONSE_STATUSES.SUCCESS) {
        dispatch(setCountriesDictionary(responseBody));
        dispatch(setCountriesDictionaryFetchingStatus(true));
      }
    };

    if (!countriesData.isFetched) {
      fetchCountriesData();
    }
  }, [countriesData]);

  if (!countriesData.isFetched) {
    return null;
  }

  return (
    <ChangeAddressPopupLayout
      onSubmitClick={handleSubmitClick}
      cityId={user?.profile?.city?.id}
      stateId={user?.profile?.state?.id}
      countryId={user?.profile?.country?.id}
      isLoading={isLoading}
      countriesDictionary={countriesData.countriesDictionary.data}
      onCancelClick={handleCancelClick}
    />
  );
};

export default ChangeAddressPopup;
